"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artistStencilDefinition = void 0;
const properties_1 = require("../properties");
const no_monetization_property_1 = require("../properties/no-monetization.property");
const participating_disciplines_property_1 = require("../properties/participating-disciplines.property");
const partner_profiles_property_1 = require("../properties/partner-profiles.property");
const product_related_image_property_1 = require("../properties/product-related-image.property");
const product_related_quote_property_1 = require("../properties/product-related-quote.property");
const seo_title_property_1 = require("../properties/seo-title.property");
const social_links_property_1 = require("../properties/social-links.property");
const social_title_property_1 = require("../properties/social-title.property");
const social_wall_property_1 = require("../properties/social-wall.property");
const soft_facts_property_1 = require("../properties/soft-facts.property");
const sound_bite_property_1 = require("../properties/sound-bite.property");
const subheading_property_1 = require("../properties/subheading.property");
const surname_property_1 = require("../properties/surname.property");
const track_records_property_1 = require("../properties/track-records.property");
const uri_title_property_1 = require("../properties/uri-title.property");
const url_property_1 = require("../properties/url.property");
const website_property_1 = require("../properties/website.property");
exports.artistStencilDefinition = {
    view: {
        label: 'Artist',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'bio',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                            'backdrop-media',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'gender',
                            'first-name',
                            'surname',
                            'sound-bite',
                            'product-related-quote',
                            'product-related-image',
                            'date-of-birth',
                            'place-of-birth',
                            'location-of-nationality',
                            'participating-disciplines',
                            'career-start',
                        ],
                    },
                    {
                        name: 'Soft facts',
                        items: ['soft-facts'],
                    },
                    {
                        name: 'Track records',
                        items: ['track-records'],
                    },
                    {
                        name: 'Social links',
                        items: [
                            'social-links',
                            'social-wall',
                            'website',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'backdrop-media': properties_1.backdropMediaPropertyDefinition,
        bio: properties_1.bioPropertyDefinition,
        'career-start': properties_1.careerStartPropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'date-of-birth': properties_1.dateOfBirthPropertyDefinition,
        disciplines: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                properties_1.disciplinesPropertyDefinition.constraints[0],
                {
                    name: 'required',
                    argument: true,
                },
            ],
        },
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'first-name': properties_1.firstNamePropertyDefinition,
        gender: properties_1.genderPropertyDefinition,
        'header-media': {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        'location-of-nationality': properties_1.locationOfNationalityPropertyDefinition,
        'no-monetization': no_monetization_property_1.noMonetizationPropertyDefinition,
        'participating-disciplines': participating_disciplines_property_1.participatingDisciplinesPropertyDefinition,
        'partner-profiles': partner_profiles_property_1.partnerProfilesPropertyDefinition,
        'place-of-birth': properties_1.placeOfBirthPropertyDefinition,
        'product-related-image': product_related_image_property_1.productRelatedImagePropertyDefinition,
        'product-related-quote': product_related_quote_property_1.productRelatedQuotePropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'seo-title': seo_title_property_1.seoTitlePropertyDefinition,
        'social-links': social_links_property_1.socialLinksPropertyDefinition,
        'social-title': social_title_property_1.socialTitlePropertyDefinition,
        'social-wall': social_wall_property_1.socialWallPropertyDefinition,
        'soft-facts': soft_facts_property_1.softFactsPropertyDefinition,
        'sound-bite': sound_bite_property_1.soundBitePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        subheading: subheading_property_1.subheadingPropertyDefinition,
        surname: surname_property_1.surnamePropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'track-records': track_records_property_1.trackRecordsPropertyDefinition,
        'uri-title': uri_title_property_1.uriTitlePropertyDefinition,
        url: url_property_1.urlPropertyDefinition,
        website: website_property_1.websitePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'artist',
};
const isArtistStencil = (stencil) => {
    return stencil.name === exports.artistStencilDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,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